// extracted by mini-css-extract-plugin
export var cardLayout = "_5r-1";
export var paginationContainer = "_5r-0";